import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import App from '../components/App'

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page,
    supplier: state.supplier,
    flags: state.flags
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({}, {
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

const MappedApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

export default MappedApp
